import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createSelector } from 'reselect';

import { IGetInfrastructureForMapRequest } from '../../../repositories/infrastructure-caching/v1/get-infrastructure-for-map';

import { IState } from '../../../store';
import { fetchInfrastructureMap } from '../../../store/infrastructure-map';

import { IInfrastructureItem } from './types';

import { InfrastructureMapExtension as InfrastructureMapExtensionComponent } from './infrastructure-map-extention';

const mapStateToProps = createSelector([(state: IState) => state.infrastructureMap], ({ data }) => {
  return {
    bbox: data && data.bbox,
    items: ((data && data.infrastructure) || []).reduce((result, item): IInfrastructureItem[] => {
      const { category } = item;

      if (!category) {
        return result;
      }

      return [
        ...result,
        ...(item.items || []).map(company => ({
          ...company,
          category,
        })),
      ];
    }, [] as IInfrastructureItem[]),
  };
});

function mapDispatchToProps(dispatch: Dispatch<IState>) {
  return {
    fetchInfrastructureMap: (params: IGetInfrastructureForMapRequest) => {
      dispatch(fetchInfrastructureMap(params));
    },
  };
}

export const InfrastructureMapExtension = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InfrastructureMapExtensionComponent);
